movieSymbolAnimatorDU = {};
movieSymbolAnimatorDU.fadeInTweens = [];
movieSymbolAnimatorDU.skipped = false;
movieSymbolAnimatorDU.allowSkip = false;

movieSymbolAnimatorDU.playAnimation = async function (sequence, completeCallback) {
  movieSymbolAnimatorDU.sequence = sequence;
  pulseSymbolAnimation.completeCallback = completeCallback;
  movieSymbolAnimatorDU.skipped = false;
  movieSymbolAnimatorDU.allowSkip = false;

  const playMovie = gameController.canCelebrate;
  const playSingle = !gameController.canCelebrate;
  if (playMovie || playSingle) {
    movieSymbolAnimatorDU.soundFinished = true;
    if (playMovie && typeof sequence.sound !== 'undefined') {
      movieSymbolAnimatorDU.soundFinished = false;
      soundManager.play(sequence.sound, movieSymbolAnimatorDU.onSoundFinished);
    }

    // Hide reel symbols - this old reels arent used anyway
    // we could grab the current set of reels from gigabloxFactory
    // but we want to keep showing the full gigasymbol underneath
    // for (let i = 0; i < sequence.data.length; i++) {
    //   reelManager.reels[sequence.data[i].reel].showSymbolEx(sequence.data[i].row, false);
    // }

    const sequenceData = movieSymbolAnimatorDU.sequence.data;
    for (let r = 0; r < Globals.NUM_REELS; r++) {
      if (movieSymbolAnimatorDU.skipped !== true) {
        const symbolAnims = [];
        const borderSequence = [];
        for (let i = 0; i < sequenceData.length; i++) {
          if (sequenceData[i].reel === r) {
            const reel = reelManager.reels[sequenceData[i].reel];
            borderSequence.push(sequenceData[i]);
            // should only have 1 linked animation
            for (let j = 0; j < reel.linkedAnimations.length; j++) {
              const animStrip = reel.linkedAnimations[j];
              // allow us to play a different movie - which lasts the same amount of time, e.g. canCelebrate
              const offset = playMovie ? 0 : 13;
              const anim = animStrip.showAnimation(sequenceData[i].row, sequenceData[i].symbolIndex + offset);
              anim.alpha = 0;
              symbolAnims.push(anim);
            }
          }
        }

        const borderAnims = symbolWinBorderAnim.playAnimation(borderSequence, null);
        const allAnims = symbolAnims.concat(borderAnims);
        if (allAnims.length > 0) {
          // so we can skip if needed
          movieSymbolAnimatorDU.fadeInTweens[r] = gsap.fromTo(allAnims, { alpha: 0 }, { alpha: 1, duration: 0.2 });
        }

        await timerManager.delayAsync(100);
      }
    }

    // ????????
    // should the anims not play until all of them have been picked?
    // so they are all in sequence
    // the fade stagger is just the alpha, the anims all loop at the same time
    // may look odd them being static then start to play?

    // movieSymbolAnimatorDU.playBorderAnim(borderSequence);
  } else {
  }

  movieSymbolAnimatorDU.allowSkip = true;

  // again, do we need to listen for updates when we want to leave the anims in place
  // when finished - we do because that fires the event
  // its upto the flow to remove later on
  Reflex.addToUpdate(movieSymbolAnimatorDU.update);
};

movieSymbolAnimatorDU.playAnimationNEW = async function (sequence, completeCallback) {
  movieSymbolAnimatorDU.sequence = sequence;
  pulseSymbolAnimation.completeCallback = completeCallback;
  movieSymbolAnimatorDU.skipped = false;

  const playMovie = gameController.canCelebrate;
  const playSingle = !gameController.canCelebrate;
  if (playMovie || playSingle) {
    movieSymbolAnimatorDU.soundFinished = true;
    if (playMovie && typeof sequence.sound !== 'undefined') {
      movieSymbolAnimatorDU.soundFinished = false;
      soundManager.play(sequence.sound, movieSymbolAnimatorDU.onSoundFinished);
    }

    // Hide reel symbols - this old reels arent used anyway
    // we could grab the current set of reels from gigabloxFactory
    // but we want to keep showing the full gigasymbol underneath
    // for (let i = 0; i < sequence.data.length; i++) {
    //   reelManager.reels[sequence.data[i].reel].showSymbolEx(sequence.data[i].row, false);
    // }

    const sequenceData = movieSymbolAnimatorDU.sequence.data;
    const symbolAnims = [];
    const borderAnims = [];
    for (let r = 0; r < Globals.NUM_REELS; r++) {
      symbolAnims[r] = [];
      borderAnims[r] = [];

      const borderSequence = [];
      for (let i = 0; i < sequenceData.length; i++) {
        if (sequenceData[i].reel === r) {
          const reel = reelManager.reels[sequenceData[i].reel];
          borderSequence.push(sequenceData[i]);
          // should only have 1 linked animation
          for (let j = 0; j < reel.linkedAnimations.length; j++) {
            const animStrip = reel.linkedAnimations[j];
            // allow us to play a different movie - which lasts the same amount of time, e.g. canCelebrate
            const offset = playMovie ? 0 : 13;
            const anim = animStrip.showAnimation(sequenceData[i].row, sequenceData[i].symbolIndex + offset);
            anim.alpha = 0;
            symbolAnims[r].push(anim);
          }
        }
      }

      borderAnims[r] = symbolWinBorderAnim.playAnimation(borderSequence, null);
    }

    for (let r = 0; r < Globals.NUM_REELS; r++) {
      const allAnims = symbolAnims[r].concat(borderAnims[r]);
      if (allAnims.length > 0) {
        movieSymbolAnimatorDU.fadeInTweens[r] = gsap.fromTo(allAnims, { alpha: 0 }, { alpha: 1, duration: 0.2 });
        await timerManager.delayAsync(187); // 50 feels a little too quick
      }
    }
  } else {
  }

  Reflex.addToUpdate(movieSymbolAnimatorDU.update);
};

movieSymbolAnimatorDU.skipAnimation = function () {
  if (movieSymbolAnimatorDU.skipped !== true) {
    movieSymbolAnimatorDU.skipped = true;
    movieSymbolAnimatorDU.allowSkip = false;
    console.log('movieSymbolAnimatorDU.skipAnimation');
    if (checkForDefined(movieSymbolAnimatorDU.sequence.sound)) {
      soundManager.stop(movieSymbolAnimatorDU.sequence.sound);
    }
    movieSymbolAnimatorDU.soundFinished = true;

    for (let i = 0; i < movieSymbolAnimatorDU.fadeInTweens.length; i++) {
      const tween = movieSymbolAnimatorDU.fadeInTweens[i];
      if (tween && (tween.isActive() || tween.time() < tween.startTime())) {
        tween.totalProgress(1);
      }
    }

    const sequenceData = movieSymbolAnimatorDU.sequence.data;
    for (let i = 0; i < sequenceData.length; i++) {
      const linkedAnims = reelManager.reels[sequenceData[i].reel].linkedAnimations;
      for (let j = 0; j < linkedAnims.length; j++) {
        const row = sequenceData[i].row;
        if (linkedAnims[j].isAnimationPlaying(row)) {
          linkedAnims[j].stopAnimation(row, 'first');
        }
      }
    }

    // Reflex.removeFromUpdate(movieSymbolAnimatorDU.update);
    // movieSymbolAnimatorDU.clearAnimations();
    // if (pulseSymbolAnimation.completeCallback) {
    //   pulseSymbolAnimation.completeCallback();
    // }
  }
};

movieSymbolAnimatorDU.onSoundFinished = function () {
  movieSymbolAnimatorDU.soundFinished = true;
};

movieSymbolAnimatorDU.update = function () {
  if (movieSymbolAnimatorDU.isAnimationComplete()) {
    console.log('movieSymbolAnimatorDU.update - all symbol anims complete');

    if (movieSymbolAnimatorDU.skipped === true) {
      // do we also want to remove the border?
      // lets say yes for now
      symbolWinBorderAnim.stopAllAnimations();
    }

    // movieSymbolAnimatorDU.clearAnimations();
    // movieSymbolAnimatorDU.playBorderAnim();
    Reflex.removeFromUpdate(movieSymbolAnimatorDU.update);
    if (pulseSymbolAnimation.completeCallback) {
      pulseSymbolAnimation.completeCallback();
    }
  }
};

movieSymbolAnimatorDU.isAnimationComplete = function () {
  const sequenceData = movieSymbolAnimatorDU.sequence.data;
  for (let i = 0; i < sequenceData.length; i++) {
    const linkedAnimations = reelManager.reels[sequenceData[i].reel].linkedAnimations;
    for (let j = 0; j < linkedAnimations.length; j++) {
      const linkedAnim = linkedAnimations[j];
      if (linkedAnim.isAnimationPlaying(sequenceData[i].row)) {
        return false;
      }
    }
  }

  return true;
};

movieSymbolAnimatorDU.clearAnimations = function (callback) {
  pulseSymbolAnimation.completeCallback = callback;
  for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
    for (j = 0; j < reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations.length; j++) {
      var animStrip = resourceManager.get(
        reelManager.reels[movieSymbolAnimatorDU.sequence.data[i].reel].linkedAnimations[j].name
      );
      animStrip.hideAllAnimations();
    }
  }

  symbolWinBorderAnim.stopAllAnimations();

  // Show reel symbols
  for (var i = 0; i < movieSymbolAnimatorDU.sequence.data.length; i++) {
    let x = movieSymbolAnimatorDU.sequence.data[i].reel;
    let y = movieSymbolAnimatorDU.sequence.data[i].row;
    reelManager.reels[x].showSymbolEx(y, true);
  }

  if (pulseSymbolAnimation.completeCallback) {
    pulseSymbolAnimation.completeCallback();
  }
  // we may fade them off or something rather than just remove immediately
  // but until then, the callback above it enough
  // Reflex.addToUpdate(movieSymbolAnimatorDU.update);
};

movieSymbolAnimatorDU.playBorderAnim = function (sequence) {
  symbolWinBorderAnim.playAnimation(sequence, null);
};

// movieSymbolAnimatorDU.borderAnimComplete = function () {
//   pulseSymbolAnimation.completeCallback();
// };

resourceManager.registerPlugIn('movieSymbolAnimatorDU', movieSymbolAnimatorDU);
